<template>
  <div v-loading="loading">
    <h3>Formula Constant Form - {{ $route.params.id ? 'Edit' : 'Create' }}</h3>
    <hr class="my-4" />
    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        :model="formData"
        :rules="validationRules"
        size="medium"
        label-width="auto"
      >
        <el-form-item label="Constanta Name" prop="VarName">
          <el-input
            v-model="formData.VarName"
            placeholder="Constanta Name"
          ></el-input>
        </el-form-item>
        <el-form-item label="Constanta Value" prop="Source_1">
          <el-input
            v-model="formData.Source_1"
            placeholder="Value"
            v-input-mask
            data-inputmask="'alias': 'currency', 'allowMinus': false, 'digits': 4"
            class="w-1/4"
          ></el-input>
        </el-form-item>

        <hr class="my-4" />
        <div class="w-full text-right">
          <el-button type="primary" @click="submit">Submit</el-button>
          <el-button @click="cancel">Cancel</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
// import { DxButton } from 'devextreme-vue'

let service

export default {
  components: {},
  created() {
    service = new formService(this, formHelper)
  },
  async mounted() {
    this.loading = true
    this.formData = await service.initialFormData()
    this.loading = false
  },
  data() {
    return {
      apiGetById: this.$appInfo.api.formula.getById,
      apiPost: this.$appInfo.api.formula.post,
      apiPut: this.$appInfo.api.formula.put,
      formData: formHelper.getEmptyData(),
      validationRules: formHelper.getValidationRule(),
      permissions: [],
      loading: false
    }
  },
  methods: {
    async cancel() {
      this.$router.go(-1)
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true

            // submit data
            await service.submit(this.formData)

            this.$message.success('Data Saved')
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
